import React from 'react'
import clsx from 'clsx'

interface HighlightedCardProps {
    bgColor: 'insights' | 'news' | 'success-stories'
    content: string;
}

export default function HighlightedCard({ bgColor, content }: HighlightedCardProps) {
    const cardClass = clsx('highlighted-card', {
        'bg-green-500': bgColor === 'insights',
        'bg-orange-050': bgColor === 'news',
        'bg-light-blue-400': bgColor === 'success-stories'
    })

    return (
        <div className={cardClass}>
            <div
                className={clsx('rich-text')}
                dangerouslySetInnerHTML={{ __html: content }}
                suppressHydrationWarning
            />
        </div>
    )
}